export default __webpack_public_path__ + "static/blob1-21698f23711c503d740d6b956a79894a.svg";